import { isTMA } from '@tma.js/sdk-react';
import { TelegramPlatform } from './telegram.js';
import { BrowserPlatform } from './browser.js';
import { User, Platform } from './types.js';

let platform: Platform;

export async function initPlatform(): Promise<Platform> {
  if (await isTMA()) {
    platform = new TelegramPlatform();
  } else {
    platform = new BrowserPlatform();
  }

  platform.applyTheme();
  return platform;
}

export { platform };
export type { User, Platform };
